import { render, staticRenderFns } from "./ActivationTaskCard.vue?vue&type=template&id=2011bd22&scoped=true&"
import script from "./ActivationTaskCard.vue?vue&type=script&lang=js&"
export * from "./ActivationTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivationTaskCard.vue?vue&type=style&index=0&id=2011bd22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011bd22",
  null
  
)

export default component.exports